<div *ngIf="heeftOndernemingen()">

    <div *ngIf="isDefAangifte">

        <form [formGroup]="ondernemingFG">
            <div formArrayName="ondernemingen">
                <div
                        *ngFor="let onderneming of ondernemingen.controls; let i = index"
                        [formGroupName]="i">
                    <div formArrayName="nietAftrekbareKosten">
                        <div *ngFor="let wuoGroup of getNietAftrekbareKosten(i).controls; let z = index"
                             [formGroupName]="z"
                             class="row"
                        >
                            <snelstart-ui-text-form-control
                                    (change)="saveForm()"
                                    [label]="z === 0 ? 'Omschrijving kosten' : ''"
                                    [required]="true"
                                    class="col-auto custom-input-250"
                                    formControlName="omschrijving"
                                    id="omschrijvingNietAftrek"
                            >
                            </snelstart-ui-text-form-control>

                            <snelstart-ui-number-form-control
                                    (change)="saveForm()"
                                    [decimals]="0"
                                    [label]="z === 0 ? 'Niet aftrekbaar' : ''"
                                    align="right"
                                    class="col-auto custom-input-150"
                                    formControlName="bedrag"
                                    id="bedragNietAftrek"
                                    prefix="€"
                            >
                            </snelstart-ui-number-form-control>

                            <snelstart-ui-button
                                    (click)="deleteNietAftrekbareKosten(i, z)"
                                    [class]="z === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                    icon="trash"
                                    iconType="light"
                                    id="buttonDeleteNiet"
                                    size="medium"
                                    type="secondary"
                            >
                            </snelstart-ui-button>
                        </div>
                    </div>

                    <div class="pb-3">
                        <snelstart-ui-button
                                (click)="addNietAftrekbareKosten(i)"
                                class="snelstart-ui-button"
                                icon="plus"
                                type="link"
                        >
                            {{ getNietAftrekbareKosten(i).length === 0 ? 'Niet/beperkt aftrekbare kosten invullen' : 'Niet/beperkt aftrekbare kosten toevoegen' }}
                        </snelstart-ui-button>
                    </div>

                </div>
            </div>
        </form>

        <form [formGroup]="ondernemingFG">
            <div formArrayName="ondernemingen">
                <div *ngFor="let onderneming of ondernemingen.controls; let i = index"
                     [formGroupName]="i">
                    <div formArrayName="wuoVrijgesteldeWinstbestanddelen">
                        <div *ngFor="let wuoGroup of getVrijgesteldeWinst(i).controls; let v = index"
                             [formGroupName]="v" class="row"
                        >
                            <snelstart-ui-text-form-control
                                    (change)="saveForm()"
                                    [label]="v === 0 ? 'Omschrijving vrijgestelde winst' : ''"
                                    [required]="true"
                                    class="custom-input-250 col-auto"
                                    formControlName="omschrijving"
                                    id="omschrijvingVrijgesteldeWinst"
                            >
                            </snelstart-ui-text-form-control>

                            <snelstart-ui-number-form-control
                                    (change)="saveForm()"
                                    [decimals]="0"
                                    [label]="v === 0 ? 'Vrijgesteld' : ''"
                                    align="right"
                                    class="custom-input-150 col-auto"
                                    formControlName="bedrag"
                                    id="bedragVrijgesteldeWinst"
                                    prefix="€"
                            >
                            </snelstart-ui-number-form-control>

                            <snelstart-ui-button
                                    (click)="deleteVrijgesteldeWinst(i, v)"
                                    [class]="v === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                    icon="trash"
                                    iconType="light"
                                    id="buttonDeleteVrijgesteldeWinst"
                                    size="medium"
                                    type="secondary"
                            >
                            </snelstart-ui-button>
                        </div>
                    </div>

                    <div class="pb-3">
                        <snelstart-ui-button
                                (click)="addVrijgesteldeWinst(i)"
                                class="snelstart-ui-button"
                                icon="plus"
                                type="link"
                        >
                            {{ getVrijgesteldeWinst(i).length === 0 ? 'Vrijgestelde winstbestanddelen invullen' : 'Vrijgestelde winstbestanddelen toevoegen' }}
                        </snelstart-ui-button>
                    </div>

                </div>
            </div>
        </form>

    </div>

    <div *ngIf="!isDefAangifte">

        <form [formGroup]="ondernemingFG">
            <div formArrayName="ondernemingen">
                <div *ngFor="let onderneming of ondernemingen.controls; let i = index"
                     [formGroupName]="i">
                    <div formArrayName="nietAftrekbareKosten">
                        <div *ngFor="let wuoGroup of getNietAftrekbareKosten(i).controls; let z = index"
                             [formGroupName]="z" class="row">
                            <snelstart-ui-text-form-control
                                    (change)="saveForm()"
                                    [label]="z === 0 ? 'Omschrijving bijtelling' : ''"
                                    [required]="true"
                                    class="col-auto custom-input-250"
                                    formControlName="omschrijving"
                                    id="omschrijving"
                            >
                            </snelstart-ui-text-form-control>

                            <snelstart-ui-number-form-control
                                    (change)="saveForm()"
                                    [decimals]="0"
                                    [label]="z === 0 ? 'Bedrag bijtelling' : ''"
                                    align="right"
                                    class="col-auto custom-input-150"
                                    formControlName="bedrag"
                                    id="bedrag"
                                    prefix="€"
                            >
                            </snelstart-ui-number-form-control>

                            <snelstart-ui-button
                                    (click)="deleteNietAftrekbareKosten(i, z)"
                                    [class]="z === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                    icon="trash"
                                    iconType="light"
                                    id="buttonDeleteInv"
                                    size="medium"
                                    type="secondary"
                            >
                            </snelstart-ui-button>
                        </div>
                    </div>

                    <div class="pb-3">
                        <snelstart-ui-button
                                (click)="addNietAftrekbareKosten(i)"
                                class="snelstart-ui-button"
                                icon="plus"
                                type="link"
                        >
                            {{ getNietAftrekbareKosten(i).length === 0 ? 'Winstbijtelling (privégebruiken, beperkt aftrekbare kosten etc.)' : 'Winstbijtelling toevoegen' }}
                        </snelstart-ui-button>
                    </div>
                </div>
            </div>
        </form>

        <!--        <div class="space20"></div>-->

        <form [formGroup]="ondernemingFG">
            <div formArrayName="ondernemingen">
                <div *ngFor="let onderneming of ondernemingen.controls; let i = index"
                     [formGroupName]="i">
                    <div formArrayName="wuoVrijgesteldeWinstbestanddelen">
                        <div *ngFor="let wuoGroup of getVrijgesteldeWinst(i).controls; let v = index"
                             [formGroupName]="v" class="row"
                        >
                            <snelstart-ui-text-form-control
                                    (change)="saveForm()"
                                    [label]="v === 0 ? 'Omschrijving aftrekpost' : ''"
                                    [required]="true"
                                    class="col-auto custom-input-250"
                                    formControlName="omschrijving"
                                    id="omschrijvingCorrectie"
                            >
                            </snelstart-ui-text-form-control>

                            <snelstart-ui-number-form-control
                                    (change)="saveForm()"
                                    [decimals]="0"
                                    [label]="v === 0 ? 'Bedrag aftrekpost' : ''"
                                    align="right"
                                    class="col-auto custom-input-150"
                                    formControlName="bedrag"
                                    id="bedragCorrectie"
                                    prefix="€"
                            >
                            </snelstart-ui-number-form-control>

                            <snelstart-ui-button
                                    (click)="deleteVrijgesteldeWinst(i, v)"
                                    [class]="v === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                    icon="trash"
                                    iconType="light"
                                    id="buttonDeleteCorrectie"
                                    size="medium"
                                    type="secondary"
                            >
                            </snelstart-ui-button>
                        </div>
                    </div>

                    <div class="pb-3">
                        <snelstart-ui-button
                                (click)="addVrijgesteldeWinst(i)"
                                class="snelstart-ui-button"
                                icon="plus"
                                type="link"
                        >
                            {{ getVrijgesteldeWinst(i).length === 0 ? 'Winstvermindering (investeringsaftrek, vrijgestelde bestanddelen etc.)' : 'Winstvermindering toevoegen' }}
                        </snelstart-ui-button>
                    </div>

                </div>
            </div>
        </form>

    </div>

</div>

<div *ngIf="!heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamPartner }} ingevuld.
    </div>
</div>
